import { PortfolioSnapshot } from '@im-marina/shared';

/** Published by the admin "Publish" action; served by CloudFront (or the dev proxy) from the media bucket. */
const SNAPSHOT_URL = import.meta.env.VITE_SNAPSHOT_URL ?? '/media/content/portfolio.json';

export async function loadSnapshot(): Promise<PortfolioSnapshot> {
  const res = await fetch(SNAPSHOT_URL, { headers: { accept: 'application/json' } });
  if (!res.ok) throw new Response('Portfolio unavailable', { status: res.status });
  return PortfolioSnapshot.parse(await res.json());
}
